import loadable from '@loadable/component';

export const OrgDashboardCartContainerLoadable = loadable(
  () => import('./OrgDashboardCartContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardCartContainer,
  },
);
